import React from "react";
import { Link } from "react-router-dom";

/**
 * Non-checkout herb suggestion — planning only, not custom fulfilment.
 * @param {{ className?: string, compact?: boolean }} props
 */
export default function SuggestHerbCallout({ className = "", compact = false }) {
  return (
    <div
      className={`rounded-2xl border border-cream bg-white/90 p-4 md:p-5 ${className}`}
      data-testid="suggest-herb-callout"
    >
      <h3 className={`font-serif text-forest ${compact ? "text-base" : "text-lg"}`}>
        Want us to consider another herb?
      </h3>
      <p className={`mt-2 text-botanical/80 leading-snug ${compact ? "text-[11px]" : "text-sm"}`}>
        Tell us what you would like to see next. We use suggestions to plan future batches, but we do not prepare unlisted
        herbs on request.
      </p>
      <Link
        to="/contact?topic=suggest-botanical"
        className={`mt-3 inline-flex items-center justify-center rounded-full border border-forest/20 bg-forest/5 font-medium text-forest hover:bg-forest hover:text-cream transition ${
          compact ? "px-4 py-2 text-xs" : "px-5 py-2.5 text-sm"
        }`}
      >
        Suggest a herb
      </Link>
    </div>
  );
}
